const MINX = 0;
const MINY = 1;
const MAXX = 2;
const MAXY = 3;

import PointCurveShape from "./PointCurveShape.js";

class Outline {
  curveshapes: PointCurveShape[];
  current: PointCurveShape | null;
  bounds: false | number[];

  constructor() {
    this.curveshapes = [];
    this.current = new PointCurveShape();
    this.bounds = false;
  }

  getShapes() {
    return this.curveshapes;
  }

  getShape(index: number) {
    return this.curveshapes[index];
  }

  /**
   * Convert the point curve to an SVG path string (bidirectional conversion?
   * You better believe it).
   */
  toSVG() {
    let svg = "";
    this.curveshapes.forEach((s) => (svg += s.toSVG()));
    return svg;
  }

  // start a shape group
  startGroup() {
    this.curveshapes = [];
  }

  // start a new shape in the group
  startShape() {
    this.current = new PointCurveShape();
  }

  // add an on-screen point
  addPoint(x: number, y: number) {
		if (!this.current) {
			throw new Error("No current shape to add point");
		}
    this.current.addPoint(x, y);
    var bounds = this.bounds;
    if (!bounds) {
      bounds = this.bounds = [x, y, x, y];
    }
    if (x < bounds[MINX]) {
      bounds[MINX] = x;
    }
    if (x > bounds[MAXX]) {
      bounds[MAXX] = x;
    }
    if (y < bounds[MINY]) {
      bounds[MINY] = y;
    }
    if (y > bounds[MAXY]) {
      bounds[MAXY] = y;
    }
  }

  // set the x/y coordinates for the left/right control points
  setLeftControl(x: number, y: number) {
		if (!this.current) {
			throw new Error("No current shape to set left control point");
		}
    this.current.setLeft(x, y);
  }

  setRightControl(x: number, y: number) {
		if (!this.current) {
			throw new Error("No current shape to set right control point");
		}
    this.current.setRight(x, y);
  }

  // close the current shape
  closeShape() {
    if (!this.current) {
			throw new Error("No current shape to close");
		}
    this.current.close();

    this.curveshapes.push(this.current);
    this.current = null;
  }

  // close the group of shapes.
  closeGroup() {
		this.closeShape();
  }
}

export default Outline;
